import React, { useEffect, useState } from 'react';
import { gql, useMutation, useQuery } from '@apollo/client';

import { Button } from 'react-bulma-components';
import DefaultError from '../components/defaulterror';
import ExerciseEditForm from '../components/exercise-edit-form';
import { Form } from 'react-bulma-components';
import { Loader } from '../components';
import { useSnackbar } from 'react-simple-snackbar';

const {Control, Field } = Form;

const GET_EXERCISE = gql`
  query GetExercise($id: String!) {
    exercise(id: $id){
      id
      title
      description
      keytonic
    }
  }
`;
const UPDATE_EXERCISE = gql`
  mutation UpdateExercise($exercise: ExerciseInput!) {
    updateExercise(exercise: $exercise){
      success
      message
      exercise {
        id
        title
        description
        keytonic
      }
    }
  }
`;
const ExerciseEdit = ({ id, closeEdit }) => {
  const [openSnackbar] = useSnackbar();
  const [exercise, setExercise] = useState({});
  const { data, loading, error } = useQuery(
    GET_EXERCISE,
    { variables: { id: id } }
  );
  const [updateExercise, { loading: mutationUpdateExerciseLoading, error: mutationUpdateExerciseError }] = useMutation(UPDATE_EXERCISE,
    {
      onError(error) {
        openSnackbar(error.message, 2000);
      },
      onCompleted(data) {
        closeEdit();
        openSnackbar(data.updateExercise.message, 2000);
      }
    });

  const handleChange = (evt) => {

    var exc = {
      id: exercise.id,
      title: exercise.title,
      description: exercise.description,
      keytonic: exercise.keytonic,
      allowUserKey: exercise.allowUserKey
    };

    switch (evt.target.name) {
      case "title":
        exc.title = evt.target.value;
        break;
      case "description":
        exc.description = evt.target.value;
        break;
      case "keytonic":
        exc.keytonic = evt.target.value;
        break;
/*       case "allowUserKey":
        exc.allowUserKey = evt.target.checked;
        break; */
    }
    setExercise(exc);
  }

  const handleSave = () => {
    updateExercise({
      variables:
      {
        exercise: exercise
      }
    })
  }

  useEffect(() => {
    if (data && data.exercise) {
      setExercise(data.exercise);
    }
  }, [data]);

  if (error) return <DefaultError error={error} />//<p>SongStep ERROR {error.message}</p>;
  if (loading) return (
    <Loader />
  );
  if (!data.exercise) {
    return <p>Broken link</p>
  }
  return (
    <>
      <ExerciseEditForm statePrefix="" item={exercise} handleChange={handleChange} id={id}/>
      <Field kind="group">
        <Control>
          <Button type="button" onClick={() => {
            closeEdit();
          }}>Back</Button>
        </Control>
        <Control>
          <Button color="success" type="button" onClick={handleSave}>Save</Button>
        </Control>
      </Field>
    </>
  )
}

export default ExerciseEdit;